import classNames from 'classnames'

import type { ReactElement } from 'react'
import type { IGlossaryEntry } from '~/types/glossary'

import EntryBlock from '../EntryBlock'

import { copyText } from '~/utils/navigator'

import './styles.scss'

interface Props {
  entry: IGlossaryEntry
  handleDeleteModalState: (isOpen: boolean, entry?: IGlossaryEntry) => VoidFunction
  handleManageModalState: (isOpen: boolean, entry?: IGlossaryEntry) => VoidFunction
  isUserAuthorizedToWrite: boolean
  withFirstChar: boolean
}

const EntryWrapper = ({
  entry,
  handleDeleteModalState,
  handleManageModalState,
  isUserAuthorizedToWrite,
  withFirstChar,
}: Props): ReactElement => {
  /** Local state */

  const classes = classNames('glossary-entry-wrapper', {
    'glossary-entry-wrapper--with-title': withFirstChar,
  })

  const firstChar = entry.title[0].toUpperCase()

  /** Handlers */

  const handleCopy = (id: string) => () => {
    copyText(`${window.location.origin}/glossary/${id}`)
  }

  /** Render */

  return (
    <div className={classes}>
      {withFirstChar ? (
        <div className="glossary-entry-wrapper--with-title__title" id={`section-${firstChar}`}>
          <span>{firstChar}</span>
        </div>
      ) : null}
      <EntryBlock
        entry={entry}
        onCopy={handleCopy(entry.glossary_item_id)}
        onDelete={isUserAuthorizedToWrite ? handleDeleteModalState(true, entry) : undefined}
        onEdit={isUserAuthorizedToWrite ? handleManageModalState(true, entry) : undefined}
      />
    </div>
  )
}

export default EntryWrapper
